import { render, staticRenderFns } from "./assignFunctionAuth.vue?vue&type=template&id=40f3fd89&scoped=true"
import script from "./assignFunctionAuth.vue?vue&type=script&lang=js"
export * from "./assignFunctionAuth.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40f3fd89",
  null
  
)

export default component.exports